import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { EventsList } from '@/components/EventsList';
import { EventDetail } from '@/components/EventDetail';
import { RaceDetail } from '@/components/RaceDetail';
import { Header } from '@/components/Header';
import { CartModal } from '@/components/CartModal';
import { Footer } from '@/components/Footer';
import { HeroSection } from '@/components/HeroSection';
import { Event, Race, Participant } from '@/types';

export const Index = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [currentView, setCurrentView] = useState<'events' | 'event' | 'race' | 'participant'>('events');
  const [selectedEvent, setSelectedEvent] = useState<Event | null>(null);
  const [selectedRace, setSelectedRace] = useState<Race | null>(null);
  const [selectedParticipant, setSelectedParticipant] = useState<Participant | null>(null);
  const [isCartModalOpen, setIsCartModalOpen] = useState(false);

  const handleEventSelect = (event: Event) => {
    setSelectedEvent(event);
    setCurrentView('event');
  };

  const handleRaceSelect = (race: Race) => {
    setSelectedRace(race);
    setCurrentView('race');
  };

  const handleParticipantSelect = (participant: Participant) => {
    setSelectedParticipant(participant);
    setCurrentView('participant');
  };

  const handleBackToEvents = () => {
    setCurrentView('events');
    setSelectedEvent(null);
  };

  const handleBackToEvent = () => {
    setCurrentView('event');
    setSelectedRace(null);
  };

  const handleCartClick = () => {
    setIsCartModalOpen(true);
  };

  const handleSearchTerm = (term: string) => {
    navigate(`/search?q=${encodeURIComponent(term)}`);
  };

  return (
    <div className="min-h-screen bg-background no-select flex flex-col">
      <Header onCartClick={handleCartClick} />
      
      <main className="flex-1">
        {currentView === 'events' && (
          <div>
            <HeroSection />
            <EventsList onEventSelect={handleEventSelect} />
          </div>
        )}
        
        {currentView === 'event' && selectedEvent && (
          <EventDetail 
            event={selectedEvent}
            onBack={handleBackToEvents}
            onRaceSelect={handleRaceSelect}
          />
        )}
        
        {currentView === 'race' && selectedRace && selectedEvent && (
          <RaceDetail 
            race={selectedRace}
            eventName={selectedEvent.name}
            eventSwissId={selectedEvent.swiss_equestrian_id}
            onBack={handleBackToEvent}
            onParticipantSelect={handleParticipantSelect}
            onCartClick={handleCartClick}
          />
        )}
        
        {currentView === 'participant' && selectedParticipant && (
          <div className="container mx-auto px-2 md:px-4 py-4 md:py-8">
            <div className="text-center">
              <h2 className="text-xl md:text-2xl font-bold mb-4">Photo Gallery Coming Soon</h2>
              <p className="text-sm md:text-base text-muted-foreground">
                iOS-style photo gallery for {selectedParticipant.rider_name} & {selectedParticipant.horse_name}
              </p>
              <button 
                onClick={handleBackToEvent}
                className="mt-4 px-4 py-2 bg-primary text-primary-foreground rounded-md text-sm md:text-base"
              >
                Back to Race
              </button>
            </div>
          </div>
        )}
      </main>
      
      <Footer />
      
      <CartModal 
        isOpen={isCartModalOpen} 
        onClose={() => setIsCartModalOpen(false)} 
      />
    </div>
  );
};

export default Index;
